module.exports = __webpack_public_path__ + "img/ic-left-menu-dash-02.96a3c635.svg";